import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../theming/themes.js';
import React, { memo, forwardRef } from 'react';
import { getDisplayName } from '../utils/reactUtils.js';

/**
 * HOC that appens the default theme to props
 * @param WrappedComponent
 */
function withDefaultTheme(WrappedComponent) {
  var forwardComponent = function forwardComponent(props, ref) {
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      ref: ref
    }, props));
  };
  forwardComponent.displayName = WrappedComponent.displayName;
  // prettier-ignore
  // @ts-ignore
  var WithDefaultTheme = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(forwardComponent));
  WithDefaultTheme.displayName = "WithDefaultTheme(".concat(getDisplayName(WrappedComponent), ")");
  // @ts-ignore
  WithDefaultTheme.defaultProps = {
    theme: themes["default"]
  };
  return WithDefaultTheme;
}

export default withDefaultTheme;
